<dx-select-box
  class="flex-grow-1 np-highlight"
  valueExpr="field"
  label="{{ 'Feld' | translate }}"
  placeholder="{{ 'Feld auswählen' | translate }}"
  [displayExpr]="getFieldDisplayExpr"
  [showClearButton]="true"
  [items]="fieldList"
  [searchEnabled]="true"
  [(value)]="pimField.field"
  (onSelectionChanged)="update()"
/>

<dx-switch *ngIf="pimField.fieldType != 'udx' && hasSystem"
           style="margin-left: 25px; align-self: center;"
           [(value)]="pimField.useSequence"
           (onValueChanged)="update()">
</dx-switch>

<dx-number-box *ngIf="hasSystem"
               class="flex-grow-1 np-highlight"
               [min]="1"
               label="{{ (pimField.useSequence ? 'Reihenfolgennummer' : 'Sortiernummer') | translate }}"
               [(value)]="pimField.systemKey"
               (onValueChanged)="onOrderChanged($event)"></dx-number-box>


<div *ngIf="hasSystem" class="d-flex align-items-center flex-shrink-0" style="margin-left: 25px;">
  <dx-switch [(value)]="pimField.currentFilter"
             (onValueChanged)="update()">
  </dx-switch>
  <span class="ms-2 text-nowrap">{{ 'Aktuell' | translate }}</span>
</div>
